import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface PostFormEmailAuthRequest {
  historyId: string;
  email: string;
}

export const postFormEmailAuth = (request: PostFormEmailAuthRequest) => {
  return api.post<ApiResponse<undefined>>(
    '/v2/viewer/submit/form-email-auth',
    request,
  );
};

const usePostFormEmailAuth = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    PostFormEmailAuthRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  PostFormEmailAuthRequest,
  QueryKey
> => {
  return useMutation(postFormEmailAuth, options);
};

export default usePostFormEmailAuth;
